import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import InteractiveTable from "../InteractiveTable";
import { bankProfileInteractiveImages } from "../../assets/js/images";
import content from "../../assets/content/content.json";
import {
  getRightContent,
  getVisibleSensorAnimation,
} from "../../assets/js/utils";
import { useSelector } from "react-redux";
import constants from "../../assets/js/constants";
import useWindowSize from "../hooks/useWindowSize";
import SimpleBanner from "../SimpleBanner";
import TapeLabel from "../TapeLabel";

function Section1(props) {
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);

  const windowWidth = useWindowSize();
  return (
    <>
      <div className="center-wrapper1">
        <SimpleBanner
          title={getRightContent(
            generalSettings.rtlLanguage,
            content.sections[sections.currentSection].content.aboutUs.title
          )}
          text={getRightContent(
            generalSettings.rtlLanguage,
            content.sections[sections.currentSection].content.aboutUs.text
          )}
        />
      </div>
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <div className="section1-header general-lp">
            <h1
              className="section1-header__heading"
              style={getVisibleSensorAnimation(
                isVisible,
                "fadeInReverse 1s backwards"
              )}
            >
              {getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content.sectionHeader
                  .title
              )}
            </h1>
            <p
              className="section1-header__sub-heading"
              style={getVisibleSensorAnimation(
                isVisible,
                "fadeIn 1s backwards"
              )}
            >
              {getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content.sectionHeader
                  .subHeading
              )}
            </p>
          </div>
        )}
      </VisibilitySensor>
      <div className="section1-table-wrapper general-lp general-rp-just-small-screen right-padding-6">
        <div className="section1-table-wrapper__first-column">
          <div className="section1-table-wrapper__first-upper-column">
            <InteractiveTable
              width={windowWidth > 767 ? "40%" : "100%"}
              title={getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content
                  .interactiveTableFirstAppeareance.title
              )}
              contents={[
                <div className="interactive-table__icons-content-row">
                  <ul className="list list--red-style">
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content
                        .interactiveTableFirstAppeareance.simpleContent
                    ).map((simpleContent, index) => (
                      <VisibilitySensor partialVisibility key={index}>
                        {({ isVisible }) => (
                          <li
                            style={getVisibleSensorAnimation(
                              isVisible,
                              `fadeIn 1s ${index * 0.3}s backwards`
                            )}
                            className="list__item"
                          >
                            {simpleContent}
                          </li>
                        )}
                      </VisibilitySensor>
                    ))}
                  </ul>
                </div>,
              ]}
            />
            <div style={{ width: windowWidth < 1024 ? "10px" : "20px" }}></div>
            <InteractiveTable
              width={windowWidth > 767 ? "60%" : "100%"}
              title={getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content
                  .interactiveTableSecondAppeareance.title
              )}
              contents={[
                <div className="interactive-table__icons-content-row">
                  <ul className="list">
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content
                        .interactiveTableSecondAppeareance.simpleHeaderContent
                    ).map((simpleHeaderContent, index) => (
                      <VisibilitySensor partialVisibility key={index}>
                        {({ isVisible }) => (
                          <li
                            style={getVisibleSensorAnimation(
                              isVisible,
                              `fadeIn 1s ${
                                windowWidth > 768 ? index * 0.5 : 0
                              }s backwards`
                            )}
                            className="list__item"
                          >
                            <h4
                              className="interactive-table__icons-content-row-header"
                              style={{ marginBottom: 0 }}
                            >
                              {simpleHeaderContent.header}
                            </h4>
                            <p
                              style={{ marginTop: "5px", marginBottom: "40px" }}
                            >
                              {simpleHeaderContent.simpleContent}
                            </p>
                          </li>
                        )}
                      </VisibilitySensor>
                    ))}
                  </ul>
                </div>,
              ]}
            />
          </div>
          <InteractiveTable
            // width="50%"
            title={getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content
                .interactiveTableThirdAppeareance.title
            )}
            icons={bankProfileInteractiveImages}
            contents={[
              <div className="interactive-table__icons-content-row">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .interactiveTableThirdAppeareance.interactiveTableIconsRow
                ).content[0].firstColumn.content.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
              </div>,
              <div className="interactive-table__icons-content-row">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <h4 className="interactive-table__icons-content-row-header">
                    {
                      getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .interactiveTableThirdAppeareance
                          .interactiveTableIconsRow
                      ).content[1].firstColumn.header
                    }
                  </h4>
                  {getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .interactiveTableThirdAppeareance.interactiveTableIconsRow
                  ).content[1].firstColumn.content.map((text, index) => (
                    <span key={index}>{text}</span>
                  ))}
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <h4
                    style={{
                      visibility: "hidden",
                    }}
                    className="interactive-table__icons-content-row-header"
                  >
                    {
                      getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .interactiveTableThirdAppeareance
                          .interactiveTableIconsRow
                      ).content[1].firstColumn.header
                    }
                  </h4>
                  {getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .interactiveTableThirdAppeareance.interactiveTableIconsRow
                  ).content[1].secondColumn.content.map((text, index) => (
                    <span key={index}>{text}</span>
                  ))}
                </div>
              </div>,
              <>
                <h4 className="interactive-table__icons-content-row-header">
                  {
                    getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content
                        .interactiveTableThirdAppeareance
                        .interactiveTableIconsRow
                    ).content[2].firstColumn.header
                  }
                </h4>
                <div className="interactive-table__icons-content-row">
                  {getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .interactiveTableThirdAppeareance.interactiveTableIconsRow
                  ).content[2].firstColumn.content.map((text, index) => (
                    <p key={index}>{text}</p>
                  ))}
                </div>
              </>,
              <>
                <h4 className="interactive-table__icons-content-row-header">
                  {
                    getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content
                        .interactiveTableThirdAppeareance
                        .interactiveTableIconsRow
                    ).content[3].firstColumn.header
                  }
                </h4>
                <div className="interactive-table__icons-content-row">
                  {getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .interactiveTableThirdAppeareance.interactiveTableIconsRow
                  ).content[3].firstColumn.content.map((text, index) => (
                    <p key={index}>{text}</p>
                  ))}
                </div>
              </>,
            ]}
          />
        </div>
        <div style={{ width: windowWidth < 1023 ? "20px" : "40px" }}></div>
        <InteractiveTable
          applyBoxShadow={true}
          width={windowWidth > 767 ? "40%" : "100%"}
          title={getRightContent(
            generalSettings.rtlLanguage,
            content.sections[sections.currentSection].content.redFilledTable
              .title
          )}
          redFilledStyle={true}
          contents={[
            <div className="interactive-table__icons-content-row white-font mt-0">
              <ul className="list lp-0">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .redFilledTable.simpleHeaderContent
                ).map((simpleHeaderContent, index) => (
                  <VisibilitySensor partialVisibility key={index}>
                    {({ isVisible }) => (
                      <li
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `fadeIn 1s ${
                            windowWidth > 768 ? index * 0.5 : 0
                          }s backwards`
                        )}
                        className="list__item"
                      >
                        <h4
                          className="interactive-table__icons-content-row-header secondary-font-color"
                          style={{ marginBottom: 0 }}
                        >
                          {simpleHeaderContent.header}
                        </h4>
                        <p style={{ marginTop: "5px", marginBottom: "40px" }}>
                          {simpleHeaderContent.simpleContent}
                        </p>
                      </li>
                    )}
                  </VisibilitySensor>
                ))}
              </ul>
            </div>,
          ]}
        />
      </div>

      <div className="mt-40 mb-40">
        <TapeLabel
          components={[
            getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.tapeLabel
            ),
          ]}
          avoidImage={true}
        />
      </div>
      {/* <div style={{ marginTop: "80px" }}> */}
      <div className="general-2m" style={{ marginBottom: "40px" }}>
        {getRightContent(
          generalSettings.rtlLanguage,
          content.sections[sections.currentSection].content.textSequence
        ).map((textSeq, index) => (
          <VisibilitySensor partialVisibility key={index}>
            {({ isVisible }) => (
              <div className=" max-width-60">
                <p
                  style={getVisibleSensorAnimation(
                    isVisible,
                    `fadeIn 1s ${index * 0.2}s backwards`
                  )}
                >
                  {textSeq}
                </p>
              </div>
            )}
          </VisibilitySensor>
        ))}
      </div>
      {/* </div> */}
      <div
        className="center-wrapper1"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <SimpleBanner
          title={getRightContent(
            generalSettings.rtlLanguage,
            content.sections[sections.currentSection].content.ourHistory.title
          )}
          text={getRightContent(
            generalSettings.rtlLanguage,
            content.sections[sections.currentSection].content.ourHistory.text
          )}
          rightAnimation={true}
        />
      </div>
    </>
  );
}

export default Section1;
